import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/services/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ToastService } from 'src/app/shared/services/toast.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  isProd = environment.production;
  isStaging = environment.isStaging;

  emailAddress: string = '';
  passwordResetToken: string = '';
  newpassword: string = '';
  retypePassword: string = '';

  creatingPassword: boolean = false;

  constructor(private userService: UserService,
    public router: Router,
    private toastService: ToastService,
    private route: ActivatedRoute) {
      this.route.queryParams.subscribe(params => {

        if(params['token'])
          this.passwordResetToken = params['token'];
      });
    }

  ngOnInit(): void {
  }

  createNewPassword() {

    this.creatingPassword = true;

    this.userService.createNewPassword({ emailAddress: this.emailAddress, passwordResetToken: this.passwordResetToken, password: this.newpassword, retypePassword: this.retypePassword  }).subscribe(response => {

          this.toastService.success("Password Updated");
          this.router.navigateByUrl('/login');
          this.creatingPassword = false;

      }, (error : any) => {

        this.creatingPassword = false;


        var errorMessage = "Password Reset Failed";
        if(error.status == 999)
          errorMessage = error.error;
        else
        {

        if (error.error !== null && error.error.message !== undefined) {
          errorMessage = error.error.message;
        }
        }

        this.toastService.error(errorMessage);

      });
  }


}
